import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyChoose from './components/WhyChoose';
import Testimonial from './components/Testimonial';
import CTA from './components/CTA';
import Footer from './components/Footer';
import About from './pages/About';
import ServicesPage from './pages/Services';
import Legal from './pages/Legal';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import TestimonialsPage from './pages/Testimonials';
import ContactPage from './pages/Contact';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

const Home = () => (
  <>
    <Hero />
    <Services />
    <WhyChoose />
    <Testimonial />
    <CTA />
  </>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="min-h-screen bg-white font-inter">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/layanan" element={<ServicesPage />} />
            <Route path="/legal" element={<Legal />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/syarat-ketentuan" element={<TermsConditions />} />
            <Route path="/testimoni" element={<TestimonialsPage />} />
            <Route path="/kontak" element={<ContactPage />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;